import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import MDTypography from '../../ui-kit/components/MDTypography';
import { PUBLIC_FOOTER_LINKS } from '../PublicSite/publicNav';

const Footer = (): JSX.Element => {
  return (
    <div className="continer-fluid">
      <MDTypography>
        &copy; 2026 Hesychia | Developed by{' '}
        <a href="https://www.aimloperations.com">AI ML Operations, LLC</a>
        {PUBLIC_FOOTER_LINKS.map((link) => (
          <React.Fragment key={link.to}>
            {' · '}
            <RouterLink to={link.to}>{link.label}</RouterLink>
          </React.Fragment>
        ))}
      </MDTypography>
    </div>
  );
};

export default Footer;
